<template>
	<div>
		<h3>{{ lot.semencelot_quantieme }} <font-awesome-icon v-if="local_lot" @click="setUpEditLot(local_lot)" :icon="['far', 'pencil-alt']" /></h3>

		<div v-if="local_lot" class="row">
			<div class="col-12">
				{{ $t('monte.congelation.observation') }} : {{ local_lot.semencelot_observation }} <br>
				{{ $t('monte.congelation.comportement') }} : {{ local_lot.semencelot_comportement }} <br>
				{{ $t('monte.congelation.commentaire') }} : {{ local_lot.semencelot_commentaire }} <br>
				{{ $t('monte.congelation.volume') }} : {{ local_lot.semencelot_volume }} <br>
				{{ $t('monte.congelation.qte') }} : {{ local_lot.semencelot_qte }} <br>
				{{ $t('monte.congelation.couleur') }} : {{ local_lot.couleur.semencecouleur_label }} <br>
				{{ $t('monte.congelation.dilueur') }} : {{ local_lot.dilueur.semencedilueur_label }}
			</div>
		</div>

		<CustomTable
            id_table="semence_lot_emplacement"
            ref="table"
            :items="emplacements"
            :busy.sync="table_busy"
            primaryKey="emplacementcongelation_id"
            :hide_if_empty="true"
            :hrefsRoutes="config_table_hrefs"
            :columsAddBegin="['preview']"
            :externSlotColumns="['preview', 'localisation_label']"
        >
            <template v-slot:[`custom-slot-cell(preview)`]="{ data }">
                <a href="" class="" @click.prevent="setUpEmplacementDetail(data)">
                    <font-awesome-icon :icon="['fas', 'eye']" />
                </a>
            </template>
            <template v-slot:[`custom-slot-cell(localisation_label)`]="{ data }">
           		{{ data.localisation_label }} <span v-if="data.localisation.semencelocalisation_command">({{ $t('monte.congelation.status.en_cours') }})</span>
            </template>
   		</CustomTable>

		<b-modal ref="modal-stock" hide-footer>
			<template v-slot:modal-title>
				{{ $t('monte.congelation.inventaire') }}
			</template>

			 <template slot="default">
			 	<div class="row">
					<div class="col-12 form-group">
						<label for="qte">{{ $t("monte.congelation.qte") }} *</label>
						<input class="form-control" type="number" v-model="qte" id="qte">
					</div>
					<div class="col-12 form-group">
						<label for="commentaire">{{ $t("monte.congelation.commentaire") }} *</label>
						<input class="form-control" type="text" v-model="commentaire" id="commentaire">
					</div>
					<div class="col-12 text-center">
			            <b-button variant="primary" @click="confirmInventaire">
			                <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse class="mr-1"/>
			                <font-awesome-icon v-else :icon="['fal', 'save']" class="mr-1"/>{{ $t('global.sauvegarder') }}
			            </b-button>
					</div>
			 	</div>
	        </template>
		</b-modal>

		<b-modal ref="modal-destroy" hide-footer>
			<template v-slot:modal-title>
				{{ $t('monte.congelation.confirm_destroy_emplacements') }}
			</template>

			 <template slot="default">
			 	<div class="row">
					<div class="col-12 form-group">
						<label for="commentaire">{{ $t("monte.congelation.commentaire") }} *</label>
						<input class="form-control" type="text" v-model="commentaire" id="commentaire">
					</div>
					<div class="col-12 text-center">
			            <b-button variant="primary" @click="confirmDestroy">
			                <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse class="mr-1"/>
			                <font-awesome-icon v-else :icon="['fal', 'trash-alt']" class="mr-1"/>{{ $t('action.detruire') }}
			            </b-button>
					</div>
			 	</div>
	        </template>
		</b-modal>

		<b-modal ref="modal-destroy-qte" hide-footer>
			<template v-slot:modal-title>
				{{ $t('monte.congelation.detruire_quantite_emplacement') }}
			</template>

			 <template slot="default">
			 	<div class="row">
					<div class="col-12 form-group">
						<label for="qte_destroy">{{ $t("monte.congelation.qte_a_detruire") }} *</label>
						<input class="form-control" type="number" min="1" :max="qte_emplacement" v-model="qte" id="qte_destroy">
					</div>
					<div class="col-12 form-group">
						<label for="commentaire_destroy">{{ $t("monte.congelation.commentaire") }} *</label>
						<input class="form-control" type="text" v-model="commentaire" id="commentaire_destroy">
					</div>
					<div class="col-12 text-center">
			            <b-button variant="primary" @click="confirmDestroyQte">
			                <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse class="mr-1"/>
			                <font-awesome-icon v-else :icon="['fal', 'trash-alt']" class="mr-1"/>{{ $t('action.detruire') }}
			            </b-button>
					</div>
			 	</div>
	        </template>
		</b-modal>

		<b-modal ref="modal-assign" hide-footer>
			<template v-slot:modal-title>
				{{ $t('monte.congelation.assign_emplacements') }}
			</template>

			 <template slot="default">
			 	<div class="row">
					<div class="col-12 form-group">
						<label for="tiers">{{ $t("tiers.tiers") }} *</label>
						<SearchTiers 
							id="tiers"
							:tiers_selected.sync="tiers_assigned"
						/>
					</div>
					<div class="col-12 form-group">
						<label for="date">{{ $t("monte.date") }} *</label>
						<e-datepicker id="date" v-model="date" mode="date"></e-datepicker>
					</div>
					<div class="col-12 text-center">
			            <b-button variant="primary" @click="confirmAssignEmplacement">
			                <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse class="mr-1"/>
			                <font-awesome-icon v-else :icon="['far', 'user']" class="mr-1"/>{{ $t('action.attribuer') }}
			            </b-button>
					</div>
			 	</div>
	        </template>
		</b-modal>

		<b-modal ref="modal-split" hide-footer>
			<template v-slot:modal-title>
				{{ $t('monte.congelation.split_stock') }}
			</template>

			 <template slot="default">
			 	<div class="row">
					<div class="col-12 form-group">
						<label for="qte">{{ $t("monte.congelation.qte") }} *</label>
						<input class="form-control" type="number" v-model="qte" id="qte">
					</div>
					<div class="col-12 form-group">
						<label for="commentaire">{{ $t("monte.congelation.commentaire") }}</label>
						<input class="form-control" type="text" v-model="commentaire" id="commentaire">
					</div>
					<div class="col-12 form-group">
						<label for="date">{{ $t("monte.date") }} *</label>
						<e-datepicker id="date" v-model="date" mode="date"></e-datepicker>
					</div>
					<div class="col-12 form-group">
                   		<label for="stockage">{{ $t("monte.stock_semence.localisation") }} *</label>
						<e-select
							v-model="localisation_selected"
							id="stockage"
							track-by="full_name"
							label="full_name"
							:placeholder="$t('monte.stock_semence.rechercher_categorie')"
							:selectedLabel="$t('global.selected_label')"
							:options="all_localisations"
							:searchable="true"
							:show-labels="false"
							:allow-empty="true"
							:sortable="false"
						>
							<template slot="option" slot-scope="props"><span :style="`padding-left: ${25 * (props.option.indent || 0) }px;`">{{ props.option.full_name }}</span></template>
						</e-select>
					</div>
					<div class="col-12 form-group">
						<label for="tiers">{{ $t("tiers.tiers") }}</label>
						<SearchTiers 
							id="tiers"
							:tiers_selected.sync="tiers_assigned"
						/>
					</div>
					<div class="col-12 text-center">
			            <b-button variant="primary" @click="confirmSplit">
			                <font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse class="mr-1"/>
			                <font-awesome-icon v-else :icon="['far', 'layer-plus']" class="mr-1"/>{{ $t('monte.congelation.split') }}
			            </b-button>
					</div>
			 	</div>
	        </template>
		</b-modal>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"
	import StockSemence from "@/mixins/StockSemence.js"
	import Navigation from "@/mixins/Navigation.js"
	import ShutterCongelation from "@/mixins/shutters-manager/Congelation.js"
	import _sortBy from "lodash/sortBy"
	import { EventBus } from 'EventBus'

	export default {
		name: 'EmplacementLot',
		mixins: [Congelation, StockSemence, Navigation, ShutterCongelation],
		props: ['lot'],
		data () {
			return {
				config_table_hrefs: {
					'proprietaire.tiers_rs': {
						routeUniqueName: 'tiersFiche',
						routeName: 'tiersFiche',
						params: {
							tiers_id: 'proprietaire.tiers_id'
						}
					}
				},
				events_tab: {
					'TableAction::goToInventaireEmplacement': this.openInventaire,
					'TableAction::goToDestroyEmplacements': this.openConfirmDestroy,
					'TableAction::goToDestroyEmplacementQte': this.openDestroyQte,
					'TableAction::goToAssignEmplacements': this.openAssign,
					'TableAction::goToSplitEmplacement': this.openSplit,
					'TableAction::goToControlEmplacement': this.setUpAddControlEmplacement,
					'TableAction::goToAddEmplacement': () => {
						this.setUpImportPaillettes(this.lot.semencelot_horse, this.lot)
					},
					'TableAction::goToLockOrUnlockNorme': this.lockOrUnlockNorme
				},
				table_busy: false,
				emplacements: [],
				edit_emplacement: null,
				processing: false,
				qte: 0,
				commentaire: '',
				emplacements_selected: [],
				tiers_assigned: null,
				date: null,
				all_localisations: [],
				localisation_selected: null,
				local_lot: null,
				qte_emplacement: 0
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.table_busy = true
				this.getEmplacementsByLot(this.lot.semencelot_id).then(res => {
					this.emplacements = res.emplacements
					this.local_lot = res.lot
					this.table_busy = false
				})
			},

			reload() {
				this.shutterPanel().close('add-control-lot')
				this.shutterPanel().close('emplacement-detail')
				this.shutterPanel().close('add-emplacement')
				this.shutterPanel().close('edit-lot')
				this.$refs.table.unselectAll()
				this.init_component()
				this.ok()
				this.focus_shutter()
			},

			openInventaire(emplacement) {
				this.edit_emplacement = emplacement
				this.qte = emplacement.emplacementcongelation_qte
				this.commentaire = ''
				this.$refs['modal-stock'].show()
			},

			async confirmInventaire() {
				if(!this.qte) 
					return false
				this.processing = true
				await this.inventaireEmplacement(this.edit_emplacement.emplacementcongelation_id, this.edit_emplacement.emplacementcongelation_qte, this.qte, this.commentaire)
				this.processing = false
				this.$refs['modal-stock'].hide()
				this.reload()
			},

			openConfirmDestroy(emplacements) {
				this.emplacements_selected = emplacements.map(empl => empl.emplacementcongelation_id)
				this.commentaire = ''
				this.$refs['modal-destroy'].show()
			},

			async confirmDestroy() {
				this.processing = true
				const floors_ids = await this.destroyEmplacements(this.emplacements_selected, this.commentaire)
				this.processing = false
				this.$refs['modal-destroy'].hide()
				this.reload()
				if(floors_ids.length > 0) {
					this.setUpDeleteFloors(floors_ids)
				}
			},

			openDestroyQte(emplacement) {
				this.edit_emplacement = emplacement
				this.qte_emplacement = emplacement.emplacementcongelation_qte
				this.qte = emplacement.emplacementcongelation_qte
				this.commentaire = ''
				this.$refs['modal-destroy-qte'].show()
			},

			async confirmDestroyQte() {
				const qte = parseInt(this.qte)
				if(isNaN(qte) || qte < 1 || qte > this.qte_emplacement) {
					return false
				}

				this.processing = true
				const floors_ids = await this.destroyEmplacementQte(this.edit_emplacement.emplacementcongelation_id, qte, this.commentaire)
				this.processing = false

				if(!floors_ids) {
					this.failureToast('toast.info_save_failed')
					return false
				}

				this.$refs['modal-destroy-qte'].hide()
				this.$refs.table.unselectAll()
				this.init_component()
				EventBus.$emit('StallionStocksListe::Reload')
				if(floors_ids.length > 0) {
					this.setUpDeleteFloors(floors_ids)
				}
			},

			openAssign(emplacements) {
				this.emplacements_selected = emplacements.map(empl => empl.emplacementcongelation_id)
				this.tiers_assigned = null
				this.date = new Date()
				this.$refs['modal-assign'].show()
			},

			async confirmAssignEmplacement() {
				if(!this.tiers_assigned || !this.date) 
					return false

				this.processing = true
				await this.assignEmplacements(this.emplacements_selected, this.tiers_assigned.tiers_id, this.date)
				this.processing = false
				this.$refs['modal-assign'].hide()
				this.reload()
			},

			async openSplit(emplacement) {
				this.edit_emplacement = emplacement
				this.qte = emplacement.emplacementcongelation_qte
				this.commentaire = ''
				this.localisation_selected = null
				this.date = new Date()
				this.tiers_assigned = null
				const all_localisations = await this.getLocalisationSemenceFullName()
				this.all_localisations = _sortBy(all_localisations.filter(loc => !loc.semencelocalisation_transport && loc.semencelocalisation_is_floor), ['parent_name', 'semencelocalisation_order'])
				this.$refs['modal-split'].show()
			},

			async confirmSplit() {
				if(this.qte > this.edit_emplacement.emplacementcongelation_qte || !this.localisation_selected || !this.date) 
					return false

				const tiers_id = this.tiers_assigned ? this.tiers_assigned.tiers_id : null

				this.processing = true
				const floors_ids = await this.splitEmplacement(this.edit_emplacement.emplacementcongelation_id, this.qte, this.localisation_selected.semencelocalisation_id, this.date, this.commentaire, tiers_id)
				this.processing = false
				this.$refs['modal-split'].hide()
				this.reload()
				if(floors_ids.length > 0) {
					this.setUpDeleteFloors(floors_ids)
				}
			},

			focus_shutter() {
				this.shutterPanel().goTo('emplacement-lot')
			},

			async lockOrUnlockNorme(emplacement) {
				await this.switchNormeNF(emplacement.emplacementcongelation_id)
				EventBus.$emit('TableAction::stopSpin')
				this.successToast()
				this.reload()
			},

			load_stocks() {
				this.reload()
			}
		},

		components: {
			CustomTable : () => import('GroomyRoot/components/Table/CustomTable'),
			SearchTiers : () => import('@/components/Contract/SearchTiers')
		}
	}

</script>